
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CookieService } from '@services/services.module';
import { Router } from '@angular/router';
import { Constants } from '@constants/constants';
import { StorageService } from '@services/storage/storage.service';

@Injectable()
export class NotAuthorizedInterceptor implements HttpInterceptor {

  constructor(
    private cookie_service: CookieService,
    private router: Router,
    private storage: StorageService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if(event.status == 401 || event.status === 0) {
              this.cookie_service.delete(Constants.UserData.TOKEN);
              this.router.navigate(['/login']);
            }
          }
          return event;
        },
        error: (error) => {
          if(error.status === 401 || error.status === 0) {
            this.storage.removeAll();
            this.cookie_service.delete(Constants.UserData.TOKEN);
            this.router.navigate(['/login']);
        }
      }
    }));
  }
}
